import React, { useContext, useEffect, useState } from "react";
import SentimentDrivers from "../SentimentDriver/SentimentDriver";
import CompetitiveSummary from "../CompetitiveSummary/CompetitiveSummary";
import { LLM_OPTIONS } from "../../../utils/constant";
import { ENTITY_LABELS } from "../../../utils/labelMapping";
import { DiscoveryContext, useIsSelectedSection } from "../discovery-context";
import classes from "./CompetitiveOverview.module.css";
import MUISelect from "../../../Component/UI/MUISelect/MUISelect";
import CategoryDimensions from "../CategoryDimensions/CategoryDimensions";
import CoreAttributes from "../CoreAttributes/CoreAttributes";
import Taxonomy from "../Taxonomy/Taxonomy";
import AttributesOverview from "../CompAttributes/CompAttributes";
import { filterKey } from "../BrandAudit";
import Checkbox from "@mui/material/Checkbox";
import { tab } from "../BrandScore/BrandScore";
import { OVERVIEW_LLM_LABELS } from "../../../utils/constant"
import DashboardCheckbox from "../SelectedComponent/DashboardCheckbox";

export default function CompetitiveOverview() {
  const discoveryCtx = useContext(DiscoveryContext);
  const entity = discoveryCtx?.entity;
  const selectedCategory = discoveryCtx?.state?.selectedCategory;
  const selectedLLM = discoveryCtx?.state?.selectedLLM;
  const selectedMarket = discoveryCtx?.state?.selectedMarket;
  const selectedPersona = discoveryCtx?.state?.selectedPersona;
  const primaryMarket = discoveryCtx?.state?.market;
  const isShowAttributeOverview = selectedMarket === primaryMarket;
  let competitors = discoveryCtx?.competitors?.[selectedCategory]?.map((c) => c.name) ?? [];
  competitors.unshift(entity);
  const selectedCompetitor = discoveryCtx?.state?.selectedCompetitor;
  let [competitorName, setCompetitorName] = useState(competitors?.[selectedCompetitor] ?? "");

  useEffect(() => {
    setCompetitorName(competitors?.[selectedCompetitor] ?? "")
  }, [selectedCompetitor])

  const id = "Sentiment_Drivers";
  const uniqueKey = `${tab.competitiveOverview}_${id}_${selectedLLM}_${selectedCategory}_${selectedMarket}_${selectedPersona}_${selectedCompetitor}`
  const { checked } = useIsSelectedSection({ id, tab: tab.competitiveOverview, uniqueKey });

  return (
    <>
      <div className={classes.containerWrapper}>
        {discoveryCtx.state.showReportCheckbox && (
                <DashboardCheckbox
                  dashboardTab={tab.competitiveOverview}
                  dashboardName={`Competitive Overview`}
                />
              )}
        <CompetitiveSummary />
        <div className={classes.headerWrapper}>
          <div style={{ display: "flex", gap: "1rem", alignItems: 'center' }}>
            <h5 className={classes.heading}>{discoveryCtx?.mapMetricTitle?.("Sentiment Drivers") ?? "Sentiment Drivers"}</h5>
            {discoveryCtx.state.showReportCheckbox && (
              <Checkbox
                checked={checked}
                onChange={() => {
                  discoveryCtx?.clickComponentCheckbox({
                    uniqueKey,
                    filter: {
                      id: id,
                      title: discoveryCtx?.mapMetricTitle?.("Sentiment Drivers") ?? "Sentiment Drivers",
                      tab: tab.competitiveOverview,
                      competitorName: competitorName,
                      competitor: selectedCompetitor,
                      uniqueKey,
                    },
                    checked,
                  });
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
            )}
          </div>
          <div className={classes.dropdownWrapper}>
            <MUISelect
              fullWidth={false}
              optionValue={discoveryCtx.state.selectedLLM}
              label={"LLM"}
              id={filterKey.llm}
              options={(discoveryCtx.llm || []).map((llm) => {
                const match = OVERVIEW_LLM_LABELS[llm]
                return {
                  name: match ? match : llm,
                  value: llm,
                };
              })}
              onChange={(e) => {
                discoveryCtx.updateSelectedLLM(e.target.value);
              }}
            />
            <MUISelect
              fullWidth={false}
              optionValue={selectedCompetitor}
              label={"Competitor"}
              id={filterKey.competitor}
              options={(competitors || []).map((competitor, index) => {
                return {
                  name: competitor,
                  value: index,
                };
              })}
              onChange={(e) => {
                discoveryCtx.updateSelectedCompetitor(e.target.value);
              }}
            />
          </div>
        </div>
        <SentimentDrivers selectedCompetitor={selectedCompetitor} />
        {isShowAttributeOverview && (
          <>
            <AttributesOverview />
            <TaxonomyAndCoreAttributes
              selectedCategory={selectedCategory}
              entity={entity}
              selectedLLM={selectedLLM}
              selectedPersona={selectedPersona}
            />
            <CategoryDimension
              selectedCategory={selectedCategory}
              entity={entity}
              selectedLLM={selectedLLM}
              selectedPersona={selectedPersona}
            />
          </>
        )}
      </div>
    </>
  );
}

let CategoryDimension = React.memo(function ({selectedLLM, selectedCategory,selectedPersona, entity }) {
  const discoveryCtx = useContext(DiscoveryContext);
  const id = "purchase_criteria";
  let uniqueKey = `${tab.competitiveOverview}_${id}_${selectedLLM}_${selectedCategory}_${selectedPersona}`;
  const { checked } = useIsSelectedSection({ id, uniqueKey });

  return (
    <div
      className={classes.section_summary}
      style={{ paddingTop: 10, paddingBottom: 10, marginTop: 20 }}
    >
      <div className="Heading-checkbox">
        <h5>Applicant Criteria</h5>

        {discoveryCtx.state.showReportCheckbox && (
          <Checkbox
            checked={checked}
            onChange={() => {
              discoveryCtx?.clickComponentCheckbox({
                uniqueKey,
                filter: {
                  id: id,
                  title: "Applicant Criteria",
                  tab: tab.competitiveOverview,
                  uniqueKey,
                },
                checked,
                id,
              });
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        )}
      </div>
      <hr />
      <div id={id}>
        <CategoryDimensions category={selectedCategory} entity={entity} />
      </div>
    </div>
  );
});

let TaxonomyAndCoreAttributes = React.memo(function ({
  selectedCategory,
  selectedLLM,
  selectedPersona,
  entity,
}) {
  const discoveryCtx = useContext(DiscoveryContext);
  const id = "TaxonomyAndCoreAttributes";
  let uniqueKey = `${tab.competitiveOverview}_${id}_${selectedLLM}_${selectedCategory}_${selectedPersona}`;
  const { checked } = useIsSelectedSection({ id, uniqueKey });
  let title =
    discoveryCtx.type === "brand" ? `${ENTITY_LABELS.Brand} Pillars` : "Product Dimension";

  return (
    <>
      <div className="Heading-checkbox">
        <h5>{title}</h5>

        {discoveryCtx.state.showReportCheckbox && (
          <Checkbox
            checked={checked}
            onChange={() => {
              discoveryCtx?.clickComponentCheckbox({
                uniqueKey,
                filter: {
                  id: id,
                  title: title,
                  tab: tab.competitiveOverview,
                  uniqueKey,
                },
                checked,
                id,
              });
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        )}
      </div>
      <hr />
      <div id={id}>
        {discoveryCtx.type === "brand" ? (
          <CoreAttributes category={selectedCategory} entity={entity} />
        ) : (
          <Taxonomy category={selectedCategory} llm={selectedLLM} />
        )}
      </div>
    </>
  );
  // }
});
